module.exports = __webpack_public_path__ + "img/marker-oil-produce-grey.2100f7d0.png";